import { baseApi } from '@/shared/api/baseApi';
import type { ApproveJoinRequestPayload, JoinRequestDto, JoinRequestStatus } from '../model/types';

const joinRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listJoinRequests: builder.query<JoinRequestDto[], { status?: JoinRequestStatus } | void>({
      query: (params) => ({ url: 'join-requests', params: params?.status ? { status: params.status } : undefined }),
      providesTags: ['JoinRequestList'],
    }),
    joinRequestCount: builder.query<{ pending: number }, void>({
      query: () => 'join-requests/count',
      providesTags: ['JoinRequestList'],
    }),
    approveJoinRequest: builder.mutation<JoinRequestDto, { id: string; body: ApproveJoinRequestPayload }>({
      query: ({ id, body }) => ({ url: `join-requests/${id}/approve`, method: 'POST', body }),
      invalidatesTags: ['JoinRequestList'],
    }),
    rejectJoinRequest: builder.mutation<JoinRequestDto, { id: string; reason: string }>({
      query: ({ id, reason }) => ({ url: `join-requests/${id}/reject`, method: 'POST', body: { reason } }),
      invalidatesTags: ['JoinRequestList'],
    }),
  }),
});

export const {
  useListJoinRequestsQuery,
  useJoinRequestCountQuery,
  useApproveJoinRequestMutation,
  useRejectJoinRequestMutation,
} = joinRequestApi;

export { joinRequestApi };
